import { render, staticRenderFns } from "./colorBox.vue?vue&type=template&id=5b42cf09&scoped=true&"
import script from "./colorBox.vue?vue&type=script&lang=js&"
export * from "./colorBox.vue?vue&type=script&lang=js&"
import style0 from "./colorBox.vue?vue&type=style&index=0&id=5b42cf09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b42cf09",
  null
  
)

export default component.exports